import { ChevronLeft } from 'baseui/icon';
import { ParagraphMedium } from 'baseui/typography';
import { Action, ActionContainer } from 'components/styles';
import useFilterHandleComponent from 'hooks/filter/use-filter-handle-component';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import styles from 'styles/Filter.module.css';

import FilterControlInput from './default-filter-control-input';
import { replaceAfterLabel } from './utils';

export interface FilterControlContentProps {
  setIsOpen: (open: boolean) => void;
  initialName?: string;
}

export default function FilterControlContent(props: FilterControlContentProps) {
  const { t } = useTranslation();

  const [selectedKey, selectKey] = React.useState<string | undefined>(
    props.initialName,
  );

  const { onGetSelectedFilter, filters } = useFilterHandleComponent();

  const selectedFilter = selectedKey
    ? onGetSelectedFilter(selectedKey)
    : undefined;

  return (
    <div className={styles.container}>
      <div className={styles.filterHeader}>
        <ActionContainer style={{ maxWidth: 40 }}>
          {selectedKey && (
            <Action onClick={() => selectKey(undefined)}>
              <ChevronLeft size={24} />
            </Action>
          )}
        </ActionContainer>
        <ParagraphMedium className={styles.title}>
          {selectedFilter?.label
            ? replaceAfterLabel(selectedFilter.label)
            : t('common:filter_by')}
        </ParagraphMedium>
        <ActionContainer style={{ maxWidth: 40 }} />
      </div>
      <div className={styles.content}>
        {selectedFilter ? (
          <FilterControlInput
            filter={selectedFilter}
            onRequestClose={() => props.setIsOpen(false)}
          />
        ) : (
          filters
            .filter((filter) => {
              if (filter.name.includes('before')) return false;
              return !filter.value;
            })
            .map((filter) => (
              <ParagraphMedium
                key={filter.name}
                className={styles.optionItem}
                onClick={() => {
                  selectKey(filter.name);
                }}
              >
                {replaceAfterLabel(filter.label)}
              </ParagraphMedium>
            ))
        )}
      </div>
    </div>
  );
}
